import { render, staticRenderFns } from "./rcvacc.vue?vue&type=template&id=22f82e43&scoped=true&"
import script from "./rcvacc.vue?vue&type=script&lang=js&"
export * from "./rcvacc.vue?vue&type=script&lang=js&"
import style0 from "./rcvacc.vue?vue&type=style&index=0&id=22f82e43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f82e43",
  null
  
)

export default component.exports